import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import LesionExcisionForm from '#forms/lesion_excision.js'

@define
export default class LesionExcisionFormStore extends Store {
    @(type(LesionExcisionForm).events({"change": "formchange"}).as) lesionExcisionForm: LesionExcisionForm
}

const store = window.store = new LesionExcisionFormStore({ id: "lesion-excision" })
export { store };
